import gql from 'graphql-tag';

import { ART_FRAGMENT } from '../fragments';

const queryName = 'allArts';

export const ALL_ENGAGEMENTS = {
  queryName,
  queryBody: gql`
    query ${queryName}(
      $before: String
      $after: String
      $first: Int
      $last: Int
      $name_Icontains: String
      $orderBy: String
    ) {
      ${queryName}(
        before: $before
        after: $after
        first: $first
        last: $last
        name_Icontains: $name_Icontains
        orderBy: $orderBy
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            ...art
          }
          cursor
        }
        totalCount
      }
    }
    ${ART_FRAGMENT}
  `,
};
